import { useAllPoolsData } from '@ui/hooks/data';
import { formatAddressForNativeToken } from '@ui/hooks/data/utils';

export const useTokenLTV = (tokenAddress?: string) => {
  const { data } = useAllPoolsData();
  const _tokenAddress = formatAddressForNativeToken(tokenAddress);
  return data?.find((item) => item.tokenAddress === _tokenAddress)
    ?.baseLTVasCollateral;
};
